import {
  Directive,
  ElementRef,
  HostListener,
  Output,
  EventEmitter
} from '@angular/core';

@Directive({
    selector: '[appInfiniteScroll]',
    standalone: false
})
export class InfiniteScrollDirective {
  @Output() scrolled = new EventEmitter<void>();
  private threshold = 100; // px from bottom to trigger load

  constructor(private el: ElementRef) {}

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    const target = this.el.nativeElement;
    const scrollPosition = target.scrollTop + target.clientHeight;
    const scrollHeight = target.scrollHeight;

    if (scrollHeight - scrollPosition <= this.threshold) {
      this.scrolled.emit();
    }
  }
}